<template>
  <div>
    <div class="container">
      <!-- ============================ 
       BOX:ほんとうに
      ============================-->
      <div
        class="flex-item item really"
        @click="onItemClick('really')"
        v-bind:class="{focus: NowFocus == 'really','item_grow':autoGrow,'item_fix':autoGrow===false,}"
      >
        <div class="header">
          <h2>
            <i class="far fa-grin-squint"></i>
            ほんとうに？?
            <span class="header-sub-title">really</span>
          </h2>
        </div>
        <div class="content">
          <quill-editor
            v-model="word.really"
            class="editor"
            ref="ReallyEditor"
            :disabled="readonly"
            :options="editorOption"
            @blur="onEditorBlur('really')"
            @focus="onEditorFocus('really')"
            @change="onEditorChange($event,'really')"
          ></quill-editor>

          <!-- ただいま編集中アイコン -->
          <transition name="fade">
            <div class="save-info" v-if="SavedEditorKind === 'really'">
              <i class="fas fa-check"></i>ほぞんしました
            </div>
          </transition>
        </div>
        <div class="word-count" v-bind:class="{zero: GetTextLength(word.really) == 0}">
          {{GetTextLength(word.really)}}
          <span>字</span>
        </div>
      </div>

      <!-- ============================ 
    BOX:スタック
      ============================-->
      <div class="flex-item stack-box">
        <!-- ============================ 
          ---BOX:メイン
        ============================-->
        <div class="item main item_fix">
          <svg
            version="1.1"
            class="arrow left-arrow"
            xmlns="http://www.w3.org/2000/svg"
            xmlns:xlink="http://www.w3.org/1999/xlink"
            x="0px"
            y="0px"
            width="52.911px"
            height="24.563px"
            viewBox="0 0 52.911 24.563"
            enable-background="new 0 0 52.911 24.563"
            xml:space="preserve"
          >
            <polygon
              fill="#B5B5B6"
              points="21.272,7.421 21.272,0 0,12.281 21.272,24.563 21.272,17.143 52.91,17.143 52.91,7.421 "
            ></polygon>
          </svg>
          <svg
            version="1.1"
            class="arrow right-arrow"
            xmlns="http://www.w3.org/2000/svg"
            xmlns:xlink="http://www.w3.org/1999/xlink"
            x="0px"
            y="0px"
            width="52.911px"
            height="24.563px"
            viewBox="0 0 52.911 24.563"
            enable-background="new 0 0 52.911 24.563"
            xml:space="preserve"
          >
            <polygon
              fill="#B5B5B6"
              points="21.272,7.421 21.272,0 0,12.281 21.272,24.563 21.272,17.143 52.91,17.143 52.91,7.421 "
            ></polygon>
          </svg>
          <svg
            version="1.1"
            class="arrow bottom-arrow"
            xmlns="http://www.w3.org/2000/svg"
            xmlns:xlink="http://www.w3.org/1999/xlink"
            x="0px"
            y="0px"
            width="52.911px"
            height="24.563px"
            viewBox="0 0 52.911 24.563"
            enable-background="new 0 0 52.911 24.563"
            xml:space="preserve"
          >
            <polygon
              fill="#B5B5B6"
              points="21.272,7.421 21.272,0 0,12.281 21.272,24.563 21.272,17.143 52.91,17.143 52.91,7.421 "
            ></polygon>
          </svg>
          <div class="header main-word">
            <h2>
              <!-- <span class="number">{{word.index}}</span> -->
              <span class="kind">Focus Word</span>
              {{word.main}}
            </h2>
          </div>
          <p class="content"></p>
        </div>

        <!-- ============================ 
       -----BOX:なぜ
        ============================-->
        <div
          class="item why mt-8"
          @click="onItemClick('why')"
          v-bind:class="{focus: NowFocus == 'why','item_grow':autoGrow,'item_fix':autoGrow===false}"
        >
          <div class="header">
            <h2>
              <i class="far fa-surprise"></i>
              なぜ?
              <span class="header-sub-title">why</span>
            </h2>
          </div>
          <div class="content">
            <quill-editor
              v-model="word.why"
              class="editor"
              ref="WhyEditor"
              :disabled="readonly"
              :options="editorOption"
              @blur="onEditorBlur('why')"
              @focus="onEditorFocus('why')"
              @change="onEditorChange($event,'why')"
            ></quill-editor>
            <!-- ただいま編集中アイコン -->
            <transition name="fade">
              <div class="save-info" v-if="SavedEditorKind === 'why'">
                <i class="fas fa-check"></i>ほぞんしました
              </div>
            </transition>
          </div>
          <div class="word-count" v-bind:class="{zero: GetTextLength(word.why) == 0}">
            {{GetTextLength(word.why)}}
            <span>字</span>
          </div>
        </div>
      </div>

      <!-- ============================ 
    BOX:それで
      ============================-->
      <div
        class="flex-item item so"
        @click="onItemClick('so')"
        v-bind:class="{focus: NowFocus == 'so','item_grow':autoGrow,'item_fix':autoGrow===false}"
      >
        <div class="header">
          <h2>
            <i class="far fa-smile"></i>
            それで?
            <span class="header-sub-title">So</span>
          </h2>
        </div>
        <div class="content">
          <quill-editor
            v-model="word.so"
            class="editor"
            ref="SoEditor"
            :options="editorOption"
            :disabled="readonly"
            @blur="onEditorBlur('so')"
            @focus="onEditorFocus('so')"
            @change="onEditorChange($event,'so')"
          ></quill-editor>
          <!-- ただいま編集中アイコン -->
          <transition name="fade">
            <div class="save-info" v-if="SavedEditorKind === 'so'">
              <i class="fas fa-check"></i>ほぞんしました
            </div>
          </transition>
        </div>
        <div class="word-count" v-bind:class="{zero: GetTextLength(word.so) == 0}">
          {{GetTextLength(word.so)}}
          <span>字</span>
        </div>
      </div>
    </div>
  </div>
</template>

 
<script>
//import "quill/dist/quill.bubble.css"; //ツールバーなし、わくなしのBubble。これを指定する必要あり。
import "../../assets/style/custom-quill.bubble.css"; //ツールバーなし、わくなしのBubble。これを指定する必要あり。
import { quillEditor } from "vue-quill-editor";
import Tloading from "../TLoading";

export default {
  name: "tthink-component",
  components: {
    "quill-editor": quillEditor,
    "t-loading": Tloading
  },
  props: {
    readonly: { type: Boolean, default: false }, //読み取り専用モード
    autoGrow: { type: Boolean, default: false } //コンテンツ内容によって縦に伸びるモード
  },
  data() {
    return {
      quillReally: null,
      quillSo: null,
      quillWhy: null,
      NowFocus: "",
      SavedEditorKind: "",
      editorOption: {
        modules: {
          //   imageResize: {
          //     displaySize: true
          //   },
          //   imageDrop: true,

          toolbar: false
        },
        placeholder: "",
        theme: "bubble", //Editor部分の線を消すため、bubbleにした。,
        timeoutIdForUpdate: "" //自動Saveに使うタイマーのIDを格納する際に使用
      }
    };
  },
  computed: {
    word() {
      return this.$store.getters.activeWord;
    }
  },
  methods: {
    GetTextLength(text) {
      var text = text.replace(/<("[^"]*"|'[^']*'|[^'">])*>/g, "");
      return text.length;
    },

    //==========================
    //Itemをクリック：Editorにフォーカスを当てる：UX向上
    //==========================
    onItemClick(kind) {
      if (kind === "really") {
        this.$refs.ReallyEditor.quill.focus();
      }
      if (kind === "so") {
        this.$refs.SoEditor.quill.focus();
      }
      if (kind === "why") {
        this.$refs.WhyEditor.quill.focus();
      }
    },
    //==========================
    //Editor:フォーカスブラー：
    //==========================
    onEditorBlur(kind) {
      if (this.NowFocus === kind) {
        this.NowFocus = "";
      }
    },
    //==========================
    //Editor:フォーカス：
    //==========================
    onEditorFocus(kind) {
      if (this.readonly) {
        return;
      }
      this.NowFocus = kind;
    },
    //==========================
    //Editor:テキストチェンジ
    //==========================
    onEditorChange({ quill, html, text }, kind) {
      //自動保存
      //負荷を小さくするため、無入力状態１秒後で内容を更新する
      clearTimeout(this.timeoutIdForUpdate);

      this.SavedEditorKind = "";

      this.timeoutIdForUpdate = setTimeout(
        function() {
          // Runs 1 second (1000 ms) after the last change
          this.$store.dispatch("UpdateWord");
          //this.SavedEditorKind ="";
          this.ShowSavedEditorInfo(kind);
        }.bind(this),
        1000
      );
    },
    ShowSavedEditorInfo(kind) {
      this.SavedEditorKind = kind;

      this.timeoutIdForUpdate = setTimeout(
        function() {
          this.SavedEditorKind = "";
        }.bind(this),
        2000
      );
    },
    setQuillEvent(quillInstance, kind) {
      quillInstance.on("text-change", (delta, oldDelta, source) => {
        this.updateWord(quillInstance.root.innerHTML, kind);
      });

      quillInstance.on(
        "selection-change",
        function(range, oldRange, source) {
          if (!range) {
            if (this.NowFocus === kind) {
              this.NowFocus = "";
            }
          } else {
            this.NowFocus = kind;
          }
        }.bind(this)
      );
    }
  },
  created() {},
  updated() {},
  mounted() {
    //  alert("mout")
    //  $('meta[name="viewport"]').prop('content', 'width=1440');
    //     if (this.$el) {
    // alert("mounted")
    //     }
    //this.ConfigQuill();
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
@import "../../assets/style/common.scss";

//=======================
//トランジション
//=======================
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter,
.fade-leave {
  opacity: 0;
}

//=======================
//P
//=======================
p {
  margin: 0;
  padding: 0;
}

//=======================
//スタックコンテナ
//=======================
.stack-box {
  display: flex;
  flex-direction: column;
}

//=======================
//Flexコンテナ
//=======================
.container {
  display: flex;
  align-items: baseline;
  flex-direction: row;
  justify-content: stretch;
  padding-bottom: 20px; // notice: 最も下端の字数が消えるのを防ぐ

  @include mq-down(md) {
    flex-direction: column; //アイテム縦並びにする
    align-items: stretch; //アイテムの幅を100%
  }
}

.flex-item {
  //overflow-x: hidden;//これをつけると下の文字数やシャドウがきえちゃうよ
  box-sizing: border-box; //padding と border の幅を要素の幅と高さに含める.
  //以下２つにより、コンテンツ内容により幅が自動でひろがるのをふせいでいる
  flex: 1 1 0;
  width: 0;
  margin-right: 8px;

  @include mq-down(md) {
    //以下２つがないと、へんなレイアウトになるのを防ぐ
    flex: 1;
    width: 100%;
  }
}

//=======================
//box:ほんとうに
//=======================
.really {
  border: 1px solid #333;
  border-radius: 10px;
  background: #f2faf6;
  box-shadow: 2px 2px 0px #aaa;

  @include mq-down(md) {
    order: 2;
  }
}

//=======================
//box:メイン
//=======================
.main {
  border: 2px solid #42b983;
  background: #42b983;
  font-weight: 600;
  border-radius: 10px;
  box-shadow: 2px 2px 0px #aaa;
  line-height: 1.5;

  @include mq-down(md) {
    order: 1;
    height: 95px !important;
    border-radius: 20px;
    & > svg {
      display: none;
    }
  }

  //縁取り文字
  -webkit-text-stroke-width: 1px;
  -webkit-text-stroke-color: #666;
  text-shadow: 1px 2px 0px #666;

  .main-word {
    z-index: 110;
  }

  .arrow {
    & > polygon {
      fill: #42b983;
    }
  }
  .left-arrow {
    position: absolute;
    top: 105px;
    left: -35px;
    z-index: 99;
    /*　画面サイズが768pxから1024pxまではここを読み込む　*/
    @media screen and (min-width: 768px) and (max-width: 1024px) {
      //矢印が文章にかかるのをふせぐ
      transform: scale(0.8);
      left: -30px;
    }
  }
  .right-arrow {
    transform: scale(-1, 1);
    position: absolute;
    top: 105px;
    right: -35px;
    z-index: 99;
     /*　画面サイズが768pxから1024pxまではここを読み込む　*/
    @media screen and (min-width: 768px) and (max-width: 1024px) {
      //矢印が文章にかかるのをふせぐ
      transform: scale(-0.8,0.8);
      right: -30px;
    }
  }

  .bottom-arrow {
    transform: rotate(-90deg);
    position: absolute;
    bottom: -20px;
    left: 43%;
    z-index: 99;
     /*　画面サイズが768pxから1024pxまではここを読み込む　*/
    @media screen and (min-width: 768px) and (max-width: 1024px) {
      //矢印が文章にかかるのをふせぐ
      transform: scale(0.8) rotate(-90deg);;
    }
  }
}

//=======================
//box:それで
//=======================
.so {
  border: 1px solid #666;
  border-radius: 10px;
  background: #f2faf6;
  box-shadow: 2px 2px 0px #aaa;
  @include mq-down(md) {
    order: 3;
  }
}

//=======================
//box:なぜ
//=======================
.why {
  border: 1px solid #666;
  border-radius: 10px;
  background: #f2faf6;
  box-shadow: 2px 2px 0px #aaa;

  @include mq-down(md) {
    order: 1;
  }
}

//=======================
//util:
//=======================
.mt-8 {
  margin-top: 8px;
}

.item_fix {
  height: 270px;
}

.item_grow {
  min-height: 270px;
}

//=======================
//flex-item
//=======================
.item {
  display: flex;
  flex-direction: column;
  //height: 250px;
  position: relative;
  padding: 0px;

  &.focus {
    box-shadow: 0px 0px 6px 1px #5eb48e;
    border: 1px solid #42b983;
    background: #dffcef;
  }

  //----------------
  //文字数
  //----------------
  & > .word-count {
    font-size: 12px;
    font-weight: 600;
    color: #268f60;
    position: absolute;
    bottom: -19px;
    right: 5px;

    &.zero {
      color: #bbb;
    }

    & > span {
      margin-left: 3px;
      font-weight: normal;
      font-size: 10px;
    }
  }

  @include mq-down(md) {
    padding: 0px;
    margin-bottom: 10px;
    & > .word-count {
      top: 15px;
      right: 15px;
    }
  }

  //--------------------------
  //ヘッダー部分
  .header {
    display: flex;
    align-items: center;
    justify-content: center;
    margin-top: 20px;

    @include mq-down(md) {
      margin-top: 5px;
    }

    &.main-word {
      & > h2 {
        margin-right: 10px;
        font-size: 26px;
        margin-left: 10px;
        color: #fff;

        @include mq-down(md) {
          font-size: 20px;
        }

        & > span.number {
          color: 42b983;
          font-size: 22px;
          display: block;
          background: white;
          width: 30px;
          line-height: 1.4;
          height: 30px;
          border-radius: 15px;
          margin: auto;
          margin-bottom: 8px;
          -webkit-text-stroke-width: 0;

          @include mq-down(md) {
            font-size: 18px;
            width: 20px;
            height: 20px;
            border-radius: 10px;
          }
        }

        //種類
        & > span.kind {
          color: 42b983;
          font-size: 14px;
          display: block;
          color: white;
          font-weight: 600;
          line-height: 1.4;
          opacity: 0.8;

          margin: auto;
          margin-bottom: 8px;
          -webkit-text-stroke-width: 0;

          @include mq-down(md) {
            font-size: 14px;
          }
        }
      }
    }

    & > h2 {
      font-size: 16px;
      color: #fff;
      //縁取り文字
      -webkit-text-stroke-width: 1px;
      -webkit-text-stroke-color: #666;
      text-shadow: 1px 2px 0px #666;

      font-weight: 900;
      margin: 0;
      margin-top: 10px;
      padding-bottom: 2px;

      & > i {
        -webkit-text-stroke-width: 0px;
        text-shadow: none;
        margin-right: 2px;
        color: #42b983;
      }
      //border-bottom:8px solid #F8E71C;
      @include mq-down(md) {
        margin-top: 14px;
        //border-bottom:5px solid #F8E71C;
      }

      & > span {
        display: block;
        text-align: center;
        color: #42b983;
        font-size: 14px;
        -webkit-text-stroke-width: 0px;
        text-shadow: none;

        &.header-sub-title {
          margin-top: 5px;
        }
      }
    }
  }

  img {
    border: 1px solid orange;
    margin: 10px;
  }

  .content {
    flex: 1;
    display: flex;
    flex-direction: column;
    //align-items: flex-start;

    overflow: hidden;
    margin-top: -8px; //notice: quill内のパディングをうちけし、無駄な余白をつめている
    margin-left: 20px;
    margin-right: 15px;
    // margin-bottom:15px;

    /*　画面サイズが768pxから1024pxまではここを読み込む　*/
    @media screen and (min-width: 768px) and (max-width: 1024px) {
      margin-left: 0px;
      margin-right: 0px;
    }

    & > .editor {
      // font-weight: 600;
      height: 100%;
    }

    & > .save-info {
      font-size: 12px;
      text-align: center;
      position: absolute;
      bottom: 5px;
      right: 12px;
      color: #42b983;

      & > i {
        margin-right: 8px;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/organisms/TThinkEditor.vue